import api from "@/api";
export default {
  namespaced: true,
  state: { appAds: [] },
  getters: {
    getAppAds(state) {
      return state.appAds;
    },
  },
  mutations: {
    SetAppAds(state, data) {
      state.appAds = data || [];
    },
  },
  actions: {
    fetchAllAppAds({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("/appAds/getAll")
          .then((res) => {
            commit("SetAppAds", res.data.data);
            resolve(res.data.data);
          })
          .catch((err) => reject(err));
      });
    },
    addAppAd({}, formData) {
      return api().post("/appAds/add", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("JwtToken"),
        },
      });
    },
    updateAppAd({}, formData) {
      return api().post("/appAds/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("JwtToken"),
        },
      });
    },
    deleteAppAd({}, id) {
      const formData = new FormData();
      formData.append("id", id);
      return api().post("/appAds/delete", formData, {
        headers: { Authorization: localStorage.getItem("JwtToken") },
      });
    },
  },
};
